import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import AnalyticsResponseRollupCollection from 'components/insights/query/AnalyticsResponseRollupCollection';

import ReferralDetailsHeader from './ReferralDetailsHeader';
import ReferralDetailsTable from './ReferralDetailsTable';

type Props = {
  loading: boolean;
  rollups: AnalyticsResponseRollupCollection;
};

export default function ReferralDetailsSection({ loading, rollups }: Props) {
  return (
    <SectionCard>
      <ReferralDetailsHeader />
      <TableWrapper>
        <ReferralDetailsTable loading={loading} rollups={rollups} />
      </TableWrapper>
    </SectionCard>
  );
}

const SectionCard = styled(Card)`
  padding: 0;
  min-height: 200px;
  max-height: 640px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
`;

const TableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 24px 24px;
  overflow: hidden;

  td:first-child:not(:last-child),
  th:first-child {
    border-right: 1px solid ${({ theme }) => theme.colors.black10};
  }

  thead {
    background-color: ${({ theme }) => theme.colors.white};
  }

  thead tr {
    border-bottom: 1px solid ${({ theme }) => theme.colors.black10};
  }

  tbody {
    border-top: none;
  }
`;
